import { useQuery } from '@tanstack/react-query'
import * as R from 'remeda'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { applyIfExist } from '~/utils'

const document = graphql(`
  query CurrentUserLanguage {
    me {
      language {
        code
      }
    }
  }
`)

type UseCurrentUserQueryOptions = {
  enabled?: boolean
}

export const useCurrentUserQuery = (
  { enabled = true }: UseCurrentUserQueryOptions = { enabled: true },
) => {
  const graphQLRequest = useGraphQLRequest()

  return useQuery({
    queryKey: ['CurrentUserLanguage'],
    queryFn: async () => {
      const result = await graphQLRequest({ document })

      return R.pipe(
        result.me,
        applyIfExist((me) => ({
          ...me,
          language: me.language ?? undefined,
        })),
      )
    },
    enabled,
  })
}
